export {NgModalModule} from './ng-modal';

export * from './ng-modal.component';